import { FormBase } from 'core/components';

export default class DaVinciBusinessPartnersForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}
	setup() {
		return {
			fields: [
				{
					name: 'description',
					label: 'DAVINCIBUSINESSPARTNERS.NAME',
					rules: 'required|string',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/seller/forms/DaVinciBusinessPartnersForm.js